const e = {
  name: "Edit",
  dimensions: { width: 21, height: 21 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1213 1.70705C15.9497 0.535478 14.0503 0.535474 12.8787 1.70705L0.292893 14.2928C0.105357 14.4804 0 14.7347 0 14.9999V19.9999C0 20.5522 0.447715 20.9999 1 20.9999H6C6.26522 20.9999 6.51957 20.8946 6.70711 20.7071L19.2929 8.12126C20.4645 6.94969 20.4645 5.0502 19.2929 3.87862L17.1213 1.70705ZM14.2929 3.12126C14.6834 2.73074 15.3166 2.73074 15.7071 3.12126L17.8787 5.29284C18.2692 5.68336 18.2692 6.31652 17.8787 6.70705L16.5 8.08573L12.9142 4.49994L14.2929 3.12126ZM11.5 5.91415L2 15.4142V18.9999H5.58579L15.0858 9.49994L11.5 5.91415Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Edit
};
